@include host-component-properties;

:host {
  --paf-icon-utilization-height-mobile: 16;
  --paf-icon-utilization-width-mobile: 19;
  --paf-icon-utilization-aspect-ratio-mobile: 19/16;
  --paf-icon-utilization-height: 20;
  --paf-icon-utilization-width: 24;
  --paf-icon-utilization-aspect-ratio: 24/20;

  &:empty {
    display: none;
  }
}

.utilization-list {
  @include reset-list;

  display: flex;
  column-gap: px-to-rem(var(--paf-global-spacing-fixed-2x));
  justify-content: flex-end;

  --paf-icon-aspect-ratio: var(--paf-icon-utilization-aspect-ratio-mobile);
  --paf-icon-width: var(--paf-icon-utilization-width-mobile);
  --paf-icon-height: var(--paf-icon-utilization-height-mobile);
}

.utilization-list:empty {
  display: none;
}

.utilization-list--level-1 {
  @include mq($from: large) {
    --paf-icon-aspect-ratio: var(--paf-icon-utilization-aspect-ratio);
    --paf-icon-width: var(--paf-icon-utilization-width);
    --paf-icon-height: var(--paf-icon-utilization-height);
  }
}

.utilization-list--level-2 {
  @include mq($to: small) {
    justify-content: flex-start;
  }

  margin-inline-end: px-to-rem(var(--paf-global-spacing-fixed-3x));
}
